import Head from "next/head";
import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import * as Toast from "@radix-ui/react-toast";
import {
  doc,
  getDoc,
  getFirestore,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { AnimatePresence, motion } from "framer-motion";
import { authError } from "../utils/errors/authError";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FiEye, FiEyeOff } from "react-icons/fi";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { load } from "@fingerprintjs/botd";
import { dbAdmin } from "../lib/firebase-admin";
import {
  IoAnalyticsOutline,
  IoFootstepsOutline,
  IoPeopleOutline,
  IoWalletOutline,
} from "react-icons/io5";
import Image from "next/image";
import { GoChecklist } from "react-icons/go";
import nookies from "nookies";
import cookie from "js-cookie";
import * as Sentry from "@sentry/browser";

import { getOGimage, getUrl } from "../utils/getUrl";
import Link from "next/link";
import { addGroup, capture, identify } from "../utils/analytics/capture";

const fetcher = async (...args) => {
  const res = await fetch(...args);

  return res.json();
};

export async function getServerSideProps(context, query) {
  const { code } = context.query;
  let cookiesPresent = context.req.cookies;
  // console.log(cookiesPresent.code)
  if (cookiesPresent.code) {
    nookies.set(undefined, "code", cookiesPresent.code, {
      maxAge: 365 * 24 * 60 * 60 * 1000,
      path: "/",
    });
  }
  if (cookiesPresent.fast_auth === "true" && cookiesPresent.session) {
    let user;

    const manager = cookiesPresent.manager;

    const uid = cookiesPresent.tag;

    // try {
    //   user = await authAdmin.verifyIdToken(cookiesPresent.session);
    // } catch (error) {
    //   console.log(error);
    // }

    if (manager === "false") {
      return {
        props: {},
      };
    }
    // console.log(user);

    // if ( user.manager && user.accessLevel === 0) {
    // return {
    //   redirect: {
    //     destination: "/lister/dashboard",
    //     permanent: true,
    //   },
    // };
    // }
    if (manager === "true") {
      const listerData = await dbAdmin.collection("Listers").doc(uid).get();
      if (!listerData.data()?.onboardingComplete) {
        return {
          redirect: {
            destination: "/lister/onboarding",
            permanent: true,
          },
        };
      }

      // return {
      //   props: {
      //     // user: JSON.stringify(listerData.data().auth),
      //     data: JSON.stringify(listerData.data()),
      //   },
      // };
      return {
        redirect: {
          destination: "/lister/dashboard",
          permanent: true,
        },
      };
    }
    return {
      props: {},
    };
  } else {
    return {
      props: {},
    };
  }
}

function PropertyManagerLanding() {
  // console.log(props)
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetPassword, setResetPassword] = useState(false);
  const [sendingResetLink, setSendingResetLink] = useState(false);
  const [resetLinkSent, setResetLinkSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const auth = getAuth();
  const user = auth.currentUser;
  const db = getFirestore();

  const [text, setText] = useState(null);

  const [passwordShown, setPasswordShown] = useState(false);

  const [open, setOpen] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [error, setError] = useState(null);

  const [activeTab, setActiveTab] = useState(0);
  const signUpBodyRef = useRef(null);
  const emailInput = useRef(null);
  const functions = getFunctions();
  const checkUser = httpsCallable(functions, "checkUser");
  const addManagerRole = httpsCallable(functions, "addManagerClaim");

  const executeScroll = async () =>
    await signUpBodyRef?.current.scrollIntoView({
      behavior: "smooth",
    });
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      if (router.query?.new === "1") {
        setActiveTab(1);
      }
      if (router.query?.code?.length > 0) {
        cookie.set("code", router.query.code, {
          expires: 365,
        });
      }
      if (cookie.get("code")?.length > 0) {
        router.replace({
          query: { ...router.query, code: cookie.get("code") },
        });
      }

      isFirstRender.current = false;

      return;
    }

    return () => {};
  }, []);

  //
  const [bot, setBot] = useState(false);
  // const { executeRecaptcha } = useGoogleReCaptcha();
  // const handleRecaptcha = useCallback(() => {
  //   if (!executeRecaptcha) {
  //     console.log("Execute recaptcha not yet available");
  //     return;
  //   }
  //   executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
  //     fetch("/api/recap", {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json, text/plain, */*",
  //         "Content-Type": "application/json",
  //       },

  //       body: JSON.stringify({
  //         gRecaptchaToken: gReCaptchaToken,
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((resp) => {
  //         // console.log(resp);
  //         if (resp?.status === "success") {
  //           // console.log(resp?.message.score);
  //           // console.log("success");
  //           if (!bot) {
  //             setBot(false);
  //           }
  //           return;
  //         } else {
  //           console.log(resp?.message);
  //           //console.log("no oerrd")
  //           setBot(true);
  //           return;
  //         }
  //       });
  //   });
  // }, [executeRecaptcha]);

  useEffect(() => {
    // if (executeRecaptcha) {
    load()
      .then((botd) => {
        return botd.detect();
      })
      .then((result) => {
        console.log(result.bot);
        setBot(result.bot);
        if (!result.bot) {
          // handleRecaptcha();
        }
      })
      .catch((error) => console.error(error));
    // }
    return () => {};
  }, []);

  const giveCode = () => {
    //abcdefghijklmnopqrstuvwxyz
    const DEFAULT_ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let id;
    function getRandomCharFromAlphabet(alphabet) {
      return alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    }
    function generateId(idDesiredLength, alphabet = DEFAULT_ALPHABET) {
      id = Array.from({ length: idDesiredLength })
        .map(() => {
          return getRandomCharFromAlphabet(alphabet);
        })
        .join("");
      return id;
    }
    const finalCode = generateId(6);
    return finalCode;
  };

  const createUser = async (email, password) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed in
        const user = userCredential.user;
        await setDoc(doc(db, "Listers", user.uid), {
          auth: {
            email: user.email,
            emailVerified: user.emailVerified,
            isAnonymous: user.isAnonymous,
            photo: user.photoURL,
            phoneNumber: user.phoneNumber,
            displayName: user.displayName,
            accessToken: user.accessToken,
            providerData: user.providerData,
            uid: user.uid,
            createdTime: user.metadata.creationTime,
            lastSignInTime: user.metadata.lastSignInTime,
          },
          createdBy: "SELF",
          code: giveCode(),
          verification: {
            emailmatch: "PENDING",
            phonematch: "PENDING",
            credibilitychecks: "PENDING",
          },
          invited_by:
            cookie.get("code")?.length > 0 ? cookie.get("code") : null,
          onboardingComplete: false,
          listerVerified: false,
          onboardingPosition: 1,
          listerInfo: {
            listerType: "INDIVIDUAL_OWNER",
            canChangeUserName: true,
            listerCounty: {
              countyID: null,
              countyName: null,
            },
            listerTown: {
              townID: null,
              townName: null,
            },
            listerArea: {
              relative: false,
              descriptor: null,
              areaName: null,
              areaID: null,
            },
          },
          currentPlan: {
            plan: "FREE",
            expires: null,
            activatedDb: serverTimestamp(),
          },
          wallet: {
            amount: 0,
            lastTopUpTime: null,
            lastDeductedTime: null,
            lastDeductedAmount: null,
            lastPlanActivated: null,
          },
          listerSocial: {},
          propertyStats: {
            totalProperties: 0,
            propertiesForRent: 0,
            propertiesForSale: 0,
            activeProperties: 0,
            activeOffMarketProperties: 0,
            activePropertiesForRent: 0,
            activePropertiesForSale: 0,
            totalActiveProperties: 0,
          },
        }).catch((err) => {
          console.log(err);
        });
        setText("Setting up...");
        let res = await addManagerRole({ uid: user.uid, property_owner: true });
        setText("Final touches...");
        await user.getIdToken(true);
        const tokenResult = await auth.currentUser.getIdTokenResult(true);
        identify({
          id: user.uid,
          properties: {
            plan: "FREE",
            ula_uid: user.uid,
            email_verified: tokenResult.claims.email_verified,
            sign_in_provider_used: tokenResult.claims.firebase.sign_in_provider,
            manager: tokenResult.claims.manager
              ? tokenResult.claims.manager
              : false,
            normal_user: tokenResult.claims.user
              ? tokenResult.claims.user
              : false,
          },
        });

        capture({
          type: "lister",
          category: "auth",
          event: "signup",
        });
        if (tokenResult.claims.manager) {
          addGroup({
            type: "lister",
            id: user.uid,
            properties: {
              date_joined: user.metadata.creationTime,
            },
          });
        } else if (tokenResult.claims.user) {
        }

        capture({
          type: "lister",
          category: "auth",
          event: "onboarding_start",
        });
        cookie.remove("code");
        // End Mixpanel Input
        router.push("/lister/onboarding").then(() => {
          setLoading(false);
        });
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        setError({ errorCode, errorMessage });
        setLoading(false);
        setOpen(true);
      });
  };

  const signInLister = async (email, password) => {
    signInWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        // Signed in
        const user = userCredential.user;
        const tokenResult = await auth.currentUser.getIdTokenResult(true);
        // console.log(tokenResult.claims)
        if (tokenResult.claims.manager) {
          Sentry.setUser({ email: user.email, id: user.uid });
          // Mixpanel Input

          identify({
            id: user.uid,
            properties: {
              ula_uid: user.uid,
              email_verified: tokenResult.claims.email_verified,
              sign_in_provider_used:
                tokenResult.claims.firebase.sign_in_provider,
              manager: tokenResult.claims.manager
                ? tokenResult.claims.manager
                : false,
              normal_user: tokenResult.claims.user
                ? tokenResult.claims.user
                : false,
            },
          });

          capture({
            type: "lister",
            category: "auth",
            event: "signin",
          });
          if (tokenResult.claims.manager) {
            addGroup({
              type: "lister",
              id: user.uid,
              properties: {
                date_joined: user.metadata.creationTime,
              },
            });
          }
          // End Mixpanel Input
          const docRef = doc(db, "Listers", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            let userData = docSnap.data();
            if (userData.onboardingComplete) {
              // onboarding complete

              router.push("/lister/dashboard").then(() => {
                setLoading(false);
              });
            } else {
              // take to onboarding

              router.push("/lister/onboarding").then(() => {
                setLoading(false);
              });
            }
          } else {
            console.log("No such lister!");
          }
        } else if (tokenResult.claims.team_member) {
          // router.push("/lister/dashboard").then(()=>{
          //   setLoading(false);
          // });
          console.log("is team member");
        } else if (tokenResult.claims.user) {
          setLoading(false);
          Sentry.setUser({ email: user.email, id: user.uid });
          // Mixpanel Input

          identify({
            id: user.uid,
            properties: {
              ula_uid: user.uid,
              email_verified: tokenResult.claims.email_verified,
              sign_in_provider_used:
                tokenResult.claims.firebase.sign_in_provider,
              manager: tokenResult.claims.manager
                ? tokenResult.claims.manager
                : false,
              normal_user: tokenResult.claims.user
                ? tokenResult.claims.user
                : false,
            },
          });
          if (tokenResult.claims.manager) {
            addGroup({
              type: "lister",
              id: user.uid,
              properties: {
                date_joined: user.metadata.creationTime,
              },
            });
          } else if (tokenResult.claims.user) {
          }
          capture({
            type: "user",
            category: "auth",
            event: "signin",
          });

          // End Mixpanel Input
          setError({
            errorCode: "auth/account-already-exists-as-user",
            errorMessage: "Use a different email account to list a property",
          });
          setOpen(true);
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // console.log(errorCode)
        setError({ errorCode, errorMessage });
        setLoading(false);

        setOpen(true);
      });
  };
  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>List Your Property - Ula</title>
        <meta
          name="description"
          content="List your property. Connect with more prospective buyers and renters and boost your sales reach"
        />
        <meta property="og:title" content={"List Your Property - Ula"} />
        <meta
          property="og:description"
          content={`List your property. Connect with more prospective buyers and renters and boost your sales reach`}
        />
        <meta property="og:url" content={`${getUrl()}/list-a-property`} />
        <meta name="og:image" content={`${getOGimage()}`} />

        <link rel="canonical" href={`${getUrl()}/list-a-property`} />
      </Head>

      <div className=" flex flex-col divide-y divide-gray-200 overflow-y-auto ">
        <main className="  flex h-full flex-col lg:flex-row">
          <Toast.Provider swipeDirection="right">
            <Toast.Root
              duration={2800}
              className=" flex flex-row justify-between space-x-0 rounded-lg border  border-red-100 bg-red-100 px-6 py-4 shadow-lg"
              open={open}
              onOpenChange={() => {
                setOpen(false);
                setError(null);
              }}
            >
              <AnimatePresence>
                {open && (
                  <motion.div
                    initial={{ opacity: 0, y: 20, scale: 0.7 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{
                      opacity: 0,
                      scale: 0.5,
                      transition: { duration: 0.6 },
                    }}
                    className="flex flex-row"
                  >
                    <div className=" flex flex-col space-y-0">
                      <Toast.Title className="  mb-0 text-base font-semibold text-red-600 ">
                        {authError(error.errorCode).title}
                      </Toast.Title>
                      <Toast.Description asChild>
                        <span className=" text-sm text-red-600">
                          {authError(error.errorCode).message}
                        </span>
                      </Toast.Description>
                    </div>
                    <Toast.Action altText="Close">
                      <button
                        onClick={() => {
                          setOpen(false);
                        }}
                        className=" invisible ml-8 rounded-md border  border-red-200 bg-transparent px-4 py-1 text-xs font-semibold text-black "
                      >
                        Close
                      </button>
                    </Toast.Action>
                    <Toast.Close />
                  </motion.div>
                )}
              </AnimatePresence>
            </Toast.Root>

            <Toast.Viewport className="  fixed bottom-0 right-0 mb-5 flex w-full max-w-screen-lg flex-col px-2 lg:mr-10 lg:w-auto lg:gap-10 lg:px-0" />
          </Toast.Provider>

          <div className=" relative flex w-full flex-col  items-start  space-y-5 bg-gray-200 px-8  pb-12 pt-6 lg:h-[90vh] lg:w-3/5 lg:space-y-12 lg:px-24 lg:py-24">
            <Image
              className=" h-full w-full object-cover brightness-[0.35] "
              layout="fill"
              alt="List your property"
              src="https://images.pexels.com/photos/5922674/pexels-photo-5922674.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            />

            <div className=" z-10 flex flex-col space-y-4 pl-0 lg:space-y-6 lg:pl-10">
              <h1 className=" text-4xl font-bold text-gray-150 lg:mt-5 lg:text-7xl ">
                List your property
                <br className="hidden lg:flex"></br> with Ula
              </h1>
              <h2 className=" mr-10 text-lg text-gray-100 lg:mr-48 lg:text-xl lg:text-gray-150">
                Reach more buyers and renters in the market.{" "}
                <br className=" flex "></br> Focus on what matters most, finding
                your next buyer and renter
              </h2>
            </div>
          </div>
          {!resetPassword ? (
            <form
              onSubmit={
                loading
                  ? () => {}
                  : async (e) => {
                      e.preventDefault();

                      if (activeTab === 0) {
                        setLoading(true);
                        // sign in user
                        await signInLister(email, password);
                      } else {
                        setLoading(true);
                        setText("Creating account...");
                        // create the user
                        await createUser(email, password);
                      }
                    }
              }
              className=" flex h-[55vh] w-full flex-col  justify-center  space-y-4 bg-white px-8 py-8  lg:h-full lg:w-2/5 lg:justify-normal lg:py-32 lg:pl-24"
              ref={signUpBodyRef}
            >
              <div className=" flex flex-col space-y-3">
                <div className=" flex flex-row items-end space-x-5">
                  <h3
                    onClick={() => {
                      if (!loading) {
                        setActiveTab(0);
                      }
                    }}
                    className={
                      "  cursor-pointer underline " +
                      (activeTab === 0
                        ? "  text-xl font-semibold text-gray-900 underline  decoration-ula-primary  decoration-4 underline-offset-8  lg:text-xl "
                        : " text-lg text-gray-900 decoration-transparent")
                    }
                  >
                    Login
                  </h3>
                  <h3
                    onClick={() => {
                      if (!loading) {
                        setActiveTab(1);
                      }
                    }}
                    className={
                      "  cursor-pointer underline " +
                      (activeTab === 1
                        ? "  text-xl font-semibold text-gray-900  decoration-ula-primary decoration-4 underline-offset-8  lg:text-xl "
                        : " text-lg text-gray-900 decoration-transparent ")
                    }
                  >
                    List property
                  </h3>
                </div>
                {activeTab === 0 ? (
                  <span className=" cursor-default select-none text-base text-gray-600">
                    Manage your property
                  </span>
                ) : (
                  <span className=" cursor-default select-none text-base text-gray-600">
                    Create an account to list property
                  </span>
                )}
              </div>

              <div className=" flex flex-col space-y-5">
                <div className="flex flex-col space-y-1">
                  <label className="font-medium text-gray-900">Email</label>
                  <input
                    ref={emailInput}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    value={email}
                    disabled={bot}
                    placeholder="Enter Email"
                    type="email"
                    className=" w-full rounded-md border border-gray-400 bg-gray-100  px-4 py-3 focus:border-ula-primary disabled:cursor-not-allowed disabled:bg-gray-200 lg:w-4/5"
                    required
                  ></input>
                </div>

                <div className="flex flex-col space-y-1">
                  <div className="flex flex-row justify-between lg:w-4/5">
                    <label className=" font-medium text-gray-900">
                      Password
                    </label>
                    <div
                      onClick={() => {
                        setPasswordShown(!passwordShown);
                      }}
                      className="group flex cursor-pointer flex-row items-center space-x-2"
                    >
                      {!passwordShown ? (
                        <FiEye className=" text-gray-700 group-hover:text-gray-700" />
                      ) : (
                        <FiEyeOff className="text-gray-700 group-hover:text-gray-700" />
                      )}
                      {passwordShown ? (
                        <span className=" text-sm text-gray-700 group-hover:text-gray-700">
                          Hide
                        </span>
                      ) : (
                        <span className=" text-sm text-gray-700 group-hover:text-gray-700">
                          Show
                        </span>
                      )}
                    </div>
                  </div>
                  <input
                    value={password}
                    placeholder="Password"
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    disabled={bot}
                    type={passwordShown ? "text" : "password"}
                    className=" w-full rounded-md border border-gray-400 bg-gray-100 px-4 py-3 focus:border-ula-primary disabled:cursor-not-allowed disabled:bg-gray-200 lg:w-4/5"
                    required
                  ></input>
                  {activeTab === 0 ? (
                    <span
                      onClick={() => {
                        setResetPassword(true);
                      }}
                      className=" cursor-pointer text-sm text-gray-700 hover:underline"
                    >
                      Forgot password
                    </span>
                  ) : null}
                </div>
              </div>

              <div className=" flex flex-col space-y-2 pt-1">
                {!loading || bot ? (
                  <button
                    disabled={bot}
                    type={bot ? "button" : "submit"}
                    className=" w-full rounded-md bg-ula-primary px-6 py-4 font-semibold text-white disabled:cursor-not-allowed disabled:bg-blue-400 lg:w-4/5"
                  >
                    {activeTab === 0 ? "Continue" : "Create account"}
                  </button>
                ) : (
                  <button
                    type="button"
                    className=" flex  w-full flex-row items-center justify-center space-x-4 rounded-md bg-ula-primary px-6 py-3 text-white lg:w-4/5"
                  >
                    <AiOutlineLoading3Quarters className="my-1 h-4 w-4 animate-spin" />
                    {activeTab === 1 ? (
                      <span className=" text-base">{text}</span>
                    ) : null}
                    {/* <span className=" text-base">Setting up...</span> */}
                    {/* <span className=" text-base">Almost there...</span> */}
                    {/* <span className=" text-base">Final touches...</span> */}

                    {/* <span className=" text-base">Preparing account...</span> */}
                    {/* <span className=" text-base">Setting up...</span> */}
                    {/* <span className=" text-base">Final touches...</span> */}
                  </button>
                )}
              </div>

              {activeTab === 1 ? (
                <div className=" flex w-full flex-row   items-center justify-center space-x-1 bg-gray-200 py-3 text-sm text-gray-700 lg:w-4/5 ">
                  <span>Are you an agent or company? </span>
                  <Link href="/hodari" passHref>
                    <a
                      onClick={() => {
                        setOpen(false);
                      }}
                      className=" cursor-pointer underline hover:text-gray-900"
                    >
                      Create account here{" "}
                    </a>
                  </Link>
                </div>
              ) : null}

              {/* <div className=" w-4/5 h-1 bg-gray-700  text-xs"></div>

          <button type="button" className=" hover:bg-gray-100 rounded-md w-4/5 py-3 border border-gray-600 flex flex-row justify-center items-center">
            <span className=" mr-4 text-lg">G</span> Continue with Google
          </button> */}
            </form>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setSendingResetLink(true);
                var actionCodeSettings = {
                  url: getUrl() + "/list-a-property",
                };

                sendPasswordResetEmail(auth, email, actionCodeSettings)
                  .then(() => {
                    setSendingResetLink(false);
                    setResetLinkSent(true);
                  })
                  .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    //   console.log(errorCode);
                    //authError(errorCode, errorMessage);
                    setError({ errorCode, errorMessage });
                    setOpen(true);
                    setSendingResetLink(false);
                    setResetLinkSent(false);
                  });
              }}
              className=" flex h-full  w-full  flex-col space-y-4  px-8 py-8 lg:w-2/5 lg:py-32 lg:pl-24"
              ref={signUpBodyRef}
            >
              {resetLinkSent ? (
                <div className=" flex flex-col space-y-1">
                  <h2 className="text-xl font-medium">
                    Forgot password link sent
                  </h2>
                  <span className=" text-sm">Check your mail app</span>
                </div>
              ) : (
                <div className=" flex flex-col space-y-1">
                  <h2 className="text-xl font-medium">Reset your password</h2>
                  <span className=" text-sm">
                    We&apos;ll email you instructions to reset your password.
                  </span>
                </div>
              )}
              <fieldset className=" mb-1 flex flex-col space-y-1">
                <label className=" font-medium text-gray-700">Email</label>
                <input
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                  autoFocus={false}
                  type="email"
                  disabled={resetLinkSent || bot}
                  placeholder="Email"
                  className=" w-full rounded-md border border-gray-400 bg-gray-100 px-4 py-3 placeholder-gray-400 focus:border-ula-primary lg:w-4/5"
                  required
                ></input>
              </fieldset>
              {sendingResetLink ? (
                <button
                  type="button"
                  className=" flex items-center justify-center rounded-md bg-ula-primary py-4 font-medium text-zinc-100 lg:w-4/5"
                >
                  <AiOutlineLoading3Quarters className="h-4 w-4 animate-spin" />
                </button>
              ) : (
                <>
                  {resetLinkSent ? (
                    <>
                      <button
                        type="button"
                        className=" flex flex-row items-center justify-center space-x-2 rounded-md bg-green-600 py-3 font-semibold text-zinc-50 lg:w-4/5"
                      >
                        <MdOutlineMarkEmailRead className=" h-5 w-5" />
                        <span>Sent</span>
                      </button>
                      <div className=" flex items-center justify-center  lg:w-4/5">
                        <span
                          className="w-auto cursor-pointer  text-center text-sm hover:underline"
                          onClick={() => {
                            setResetPassword(false);
                          }}
                        >
                          Signin
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <button
                        type="submit"
                        className="  rounded-md bg-ula-primary py-3 font-medium text-zinc-50 lg:w-4/5"
                      >
                        Send link
                      </button>
                      <div className=" flex items-center justify-center  lg:w-4/5">
                        <span
                          className="w-auto cursor-pointer  text-center text-sm hover:underline"
                          onClick={() => {
                            setResetPassword(false);
                          }}
                        >
                          Cancel
                        </span>
                      </div>
                    </>
                  )}
                </>
              )}
            </form>
          )}
        </main>

        <div className=" flex flex-col items-center space-y-12 bg-zinc-100 py-20 lg:space-y-16 lg:bg-zinc-50 lg:py-48 ">
          <div className=" flex flex-col items-center space-y-2">
            <h2 className="  font-semibold underline decoration-defaultblue-600 decoration-4 underline-offset-4">
              Why <span className=" font-bold ">Ula</span>
            </h2>
            <h3 className="text-center text-3xl font-semibold lg:text-4xl">
              Spend less time <br></br> finding buyers and renters{" "}
            </h3>
          </div>
          <div className=" flex w-full flex-col items-center space-y-12 px-8 lg:flex-row lg:items-start lg:justify-between lg:space-y-0 lg:px-32">
            <div className="  flex  h-48 w-auto max-w-[17rem] flex-col items-center space-y-3 lg:items-start">
              <div className=" flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IoWalletOutline className=" h-6 w-6 lg:h-8 lg:w-8" />
              </div>
              <div className=" flex flex-col items-center space-y-1 lg:items-start">
                <h3 className=" text-lg font-semibold lg:text-xl">
                  Get qualified leads
                </h3>
                <span className=" text-center text-gray-900 lg:text-start">
                  Increased buyer intention. 75% of visitors on ula are already
                  looking to buy and rent
                </span>
              </div>
            </div>
            <div className="  flex  h-48 w-auto max-w-[17rem] flex-col items-center space-y-3 lg:items-start">
              <div className=" flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IoPeopleOutline className="h-6 w-6 lg:h-8 lg:w-8" />
              </div>
              <div className=" flex flex-col items-center space-y-1 lg:items-start">
                <h3 className="text-lg font-semibold lg:text-xl">
                  Reach a wider tailored market
                </h3>
                <span className=" text-center text-gray-900 lg:text-start">
                  Reach more prospective searchers. Put your property in front
                  of thousands where your property is located
                </span>
              </div>
            </div>
            <div className="  flex  h-48 w-auto max-w-[17rem] flex-col items-center space-y-3 lg:items-start">
              <div className=" flex h-16 w-16 items-center justify-center rounded-full bg-gray-300">
                <IoAnalyticsOutline className=" h-6 w-6 lg:h-8 lg:w-8" />
              </div>
              <div className=" flex flex-col items-center space-y-1 lg:items-start">
                <h3 className=" text-lg font-semibold lg:text-xl">
                  Get market insights
                </h3>
                <span className=" text-center text-gray-900 lg:text-start">
                  Meaningful insights. Get insightful analytics on the market
                  and performance of your property
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className=" flex h-auto w-full flex-col lg:flex-row">
          <div className=" flex w-full flex-col space-y-10 bg-white px-8 py-12 lg:w-[55%] lg:px-32 lg:py-24">
            <span className=" text-3xl font-extrabold  text-gray-800 lg:text-5xl">
              How it works
            </span>
            <div className=" flex flex-col lg:space-y-5">
              <div className="  flex h-48 flex-col space-y-4 lg:w-88">
                <div className=" flex h-12  w-12 items-center justify-center rounded-full  bg-lightblue-400 lg:h-16  lg:w-16">
                  <MdOutlineMarkEmailRead className=" h-5 w-5 text-gray-800 lg:h-6 lg:w-6" />
                </div>
                <div className="flex flex-col space-y-1">
                  <h3 className=" text-xl font-semibold">
                    Register your account
                  </h3>
                  <span className=" text-gray-600">
                    Provide an email and password for your account. Takes less
                    than a minute.
                  </span>
                </div>
              </div>
              <div className="  flex h-48 flex-col space-y-4 lg:w-88">
                <div className="  flex h-12 w-12 items-center justify-center rounded-full bg-lightblue-400 lg:h-16 lg:w-16">
                  <IoFootstepsOutline className=" h-5 w-5 lg:h-6 lg:w-6" />
                </div>
                <div className="flex flex-col space-y-1">
                  <h3 className=" text-xl font-semibold">
                    Complete onboarding
                  </h3>
                  <span className=" text-gray-600">
                    Provide and verify contact details. We never show your phone
                    number online by default.
                  </span>
                </div>
              </div>
              <div className="  flex h-48 flex-col space-y-4 lg:w-88">
                <div className="  flex h-12 w-12 items-center justify-center rounded-full bg-lightblue-400 lg:h-16 lg:w-16">
                  <GoChecklist className=" h-5 w-5 lg:h-6 lg:w-6" />
                </div>
                <div className="flex flex-col space-y-1">
                  <h3 className=" text-xl font-semibold">List your property</h3>
                  <span className=" w-full text-gray-600">
                    Add your property and reach millions of prospective buyers
                    and renters.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className=" relative h-80 w-full bg-gray-200 lg:h-auto lg:w-[45%]">
            <Image
              className=" h-full w-full object-cover  "
              layout="fill"
              alt=""
              src="https://images.pexels.com/photos/5727892/pexels-photo-5727892.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            />
          </div>
        </div>

        <div className=" px-0 py-0 lg:px-32 lg:py-24">
          <div className=" flex flex-col items-center justify-center space-y-6 bg-ula-secondary py-12  lg:h-[65vh] lg:space-y-8 lg:rounded-md lg:py-32">
            <div className=" flex flex-col items-center justify-center space-y-4 lg:space-y-5">
              <h2 className=" text-2xl font-bold  text-gray-150 lg:text-5xl">
                List your property today
              </h2>
              <h3 className="  px-10 text-center text-base text-gray-150 lg:px-0 lg:text-lg">
                Get your property to a larger more refined market.
                <br></br> Find the next buyer and renter faster
                <br className=" hidden lg:flex"></br>
              </h3>
            </div>
            <div className="">
              <button
                onClick={async () => {
                  await executeScroll();
                  setActiveTab(1);
                  setTimeout(() => {
                    emailInput.current.focus();
                  }, 900);
                }}
                className=" w-auto rounded-md bg-blue-50 px-16 py-3 font-semibold text-gray-900"
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PropertyManagerLanding;
